module.exports = __webpack_public_path__ + "img/Icon awesome-list-ul.c2981b0f.svg";